import { RouteType } from "types/RouteType";
// import loadHoistOverviewRoute from "./LoadHoistOverview/loadHoistOverview.Route";
// import loadHoistSummaryRoute from "./LoadHoistSummary/loadHoistSummary.Route";
// import loadHoistTrackerRoute from "./LoadHoistTracker/loadHoistTracker.Route";
// import productionOverviewChartRoute from "./ProductionOverviewChart/productionOverviewChart.Route";
import productionOverviewScheduleRoute from "./ProductionOverviewSchedule/productionOverviewSchedule.Route";
import productionScheduleRoute from "./ProductionSchedule/productionSchedule.Route";
import scheduleGeneratorRoute from "./ScheduleGenerator/ScheduleGenerator.Route";
// Roadmap QC row 4 — the Rescheduling Queue moved out of the QC hub tab strip
// on 2026-08-24. It still LIVES under views/qualityControl (its components and
// its panel-rejections service are there); only its placement is here.
import reschedulingQueueRoute from "../qualityControl/ReschedulingQueue/reschedulingQueue.Route";

const schedulingRoutesList: RouteType[] = [
    // loadHoistOverviewRoute,
    // loadHoistSummaryRoute,
    // ...loadHoistTrackerRoute,
    // ...productionOverviewChartRoute,
    ...productionOverviewScheduleRoute,
    ...productionScheduleRoute,
    scheduleGeneratorRoute,
    reschedulingQueueRoute,
];

export default schedulingRoutesList;
